// extracted by mini-css-extract-plugin
export default {"card":"CustomizationCard-module__card__xBK8p","save":"CustomizationCard-module__save__IFVSg"};